export default "__VITE_ASSET__B1RC0iL4__"